<template>
  <div>
    <section id="comaparer_steps" class="px-4">
      <div class="max-w-[1440px] lg:px-8 py-[18px] mx-auto">
        <div class="flex items-center justify-between">
          <a href="/">
            <img
              width="89"
              height="18"
              src="https://punkta.pl/app/uploads/2022/04/logo.svg"
              class="img-fluid"
              alt="Punkta.pl – porównywarka OC"
            />
          </a>

          <div
            class="md:flex hidden mx-[-5px] text-xs items-center font-medium md:px-4"
          >
            <div class="px-[5px]">
              <div
                class="rounded-full w-7 h-7 border border-[#b7b7b7] relative"
              >
                <span
                  class="absolute text-black transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 text-opacity-60"
                  >1</span
                >
              </div>
            </div>
            <div class="px-[5px] text-black text-opacity-60">
              <div>Dane podróży i podróżujących</div>
            </div>
            <div class="px-[5px]">
              <div class="h-[1px] w-[74px] bg-gray-400"></div>
            </div>

            <div class="px-[5px]">
              <div class="relative bg-orange-100 rounded-full w-7 h-7">
                <span
                  class="absolute text-white transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2"
                  >2</span
                >
              </div>
            </div>
            <div class="px-[5px]">
              <div>Oferty dla Ciebie</div>
            </div>
            <div class="px-[5px]">
              <div class="h-[1px] w-[74px] bg-gray-400"></div>
            </div>

            <div class="px-[5px]">
              <div
                class="rounded-full w-7 h-7 border border-[#b7b7b7] relative"
              >
                <span
                  class="absolute text-black transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 text-opacity-60"
                  >3</span
                >
              </div>
            </div>
            <div class="px-[5px] text-black text-opacity-60">
              <div>Płatność</div>
            </div>
          </div>
          <div class="relative contact-box">
            <a
              href="//punktatravel.pl/kontakt/"
              class="flex text-xs bg-black cursor-pointer btn"
            >
              <img src="@/assets/img/incoming-call.svg" alt="call" />
              <span class="hidden ml-2 md:block"> Kontakt </span>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section id="comparer_header" class="px-4 pb-16 overflow-hidden pt-9">
      <div class="relative z-30 max-w-6xl mx-auto">
        <div class="md:w-3/4">
          <h1 class="mb-3 md:text-3xl text-2xl relative z-30 md:w-full w-70%">
            Podsumowanie wybranej oferty
          </h1>
          <p class="text-sm" style="color: #00000099">
            Wypełnij dane i przejdź do płatności
          </p>
          <div class="mr-auto md:ml-auto md:mr-0"></div>
        </div>

        <div
          class="absolute bg-orange-100 rounded-full md:w-64 md:h-64 w-36 h-36 md:right-0 md:-top-20 -top-16 -right-10"
        >
          <img
            class="absolute bottom-1/2 right-1/2 transform translate-x-1/2 translate-y-1/2 w-16 h-16 md:h-[90px] md:w-[90px]"
            src="@/assets/img/punkta_comparer/podroze.png"
            alt="icon"
          />
        </div>
      </div>
    </section>
    <section
      id="comparer_form"
      class="px-4 pt-16 pb-32 overflow-hidden bg-gray-100"
    >
      <div class="max-w-6xl mx-auto">
        <div class="flex md:mx-[-10px] flex-wrap">
          <div class="md:w-1/4 px-[10px] order-1">
            <div class="md:w-11/12">
              <h2 class="mb-5 text-2xl">Oświadczenia</h2>
              <div
                class="text-sm text-black md:text-xs text-opacity-60 mb-7 md:mb-0"
              >
                Towarzystwa ubezpieczeniowe wymagają akceptacji oświadczeń i
                zapoznania się z dokumentami przed zakupem polisy
              </div>
            </div>
          </div>

          <div class="md:w-2/4 md:px-[10px] md:order-2 order-3">
            <div class="mb-5 bg-white rounded-lg shadow-0-2-5 p-7">
              <img
                v-if="this.$store.state.starpack.logo"
                :src="this.$store.state.starpack.logo"
                style="height: 60px;"
                alt="logo"
              />
              <p
                v-if="this.$store.state.starpack.id_starpack"
                class="mt-2 mb-5 text-xs font-medium text-black text-opacity-60"
              >
                Numer oferty:
                {{ this.$store.state.starpack.id_starpack }}
              </p>
              <ul class="md:flex flex-wrap text-[13px] list-none">
                <li v-if="this.$store.state.dateFrom" class="mb-4 md:w-1/2">
                  Polisa od:
                  <strong>{{ this.$store.state.dateFrom }}</strong>
                </li>
                <li v-if="this.$store.state.dateTo" class="mb-4 md:w-1/2">
                  Polisa do:
                  <strong>{{ this.$store.state.dateTo }}</strong>
                </li>
                <li
                  v-if="
                    this.$store.state.winterSports ||
                      this.$store.state.chronicDiseases ||
                      this.$store.state.highRiskSports
                  "
                  class="mb-4 md:w-1/2"
                >
                  Wybrane rozszerzenia:
                  <strong v-if="this.$store.state.winterSports"
                    >Sporty zimowe,
                  </strong>
                  <strong v-if="this.$store.state.highRiskSports"
                    >Sporty wysokiego ryzyka,
                  </strong>
                  <strong v-if="this.$store.state.chronicDiseases"
                    >Choroby przewlekłe</strong
                  >
                </li>
              </ul>
            </div>
            <div v-if="this.$store.state.clients.length > 0">
              <div
                v-for="(item, index) in this.$store.state.clients"
                :key="item.id"
              >
                <div class="mb-5 bg-white rounded-lg shadow-0-2-5 p-7">
                  <div class="flex justify-between mb-5">
                    <div class="flex items-center">
                      <div class="relative w-12 h-12 bg-gray-100 rounded-full">
                        <img
                          class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                          src="@/assets/img/punkta_comparer/icon-account.svg"
                          alt="account"
                        />
                      </div>
                      <h3 v-if="item.insurer" class="ml-2 font-medium">
                        Osoba ubezpieczająca{{
                          item.owner ? ', uczestnik' : ''
                        }}
                      </h3>
                      <h3
                        v-if="item.owner && !item.insurer"
                        class="ml-2 font-medium"
                      >
                        Uczestnik wycieczki ({{ index }})
                      </h3>
                    </div>
                    <router-link
                      :to="
                        item.insurer ? '/' : item.owner ? '/form-step-2' : ''
                      "
                      class="relative -mt-2 border border-black rounded-lg border-opacity-20 w-11 h-11"
                      ><img
                        class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
                        src="@/assets/img/punkta_comparer/icon-pen.svg"
                        alt="pen"
                    /></router-link>
                  </div>
                  <ul class="md:flex flex-wrap text-[13px] list-none">
                    <li class="mb-4 md:w-1/2">
                      Imię: <strong>{{ item.firstname }}</strong>
                    </li>
                    <li class="mb-4 md:w-1/2">
                      Nazwisko: <strong>{{ item.surname }}</strong>
                    </li>
                    <li v-if="item.birth_date" class="mb-4 md:w-1/2">
                      Data Urodzenia: <strong>{{ item.birth_date }}</strong>
                    </li>
                    <li v-if="item.email && item.insurer" class="mb-4 md:w-1/2">
                      Adres email: <strong>{{ item.email }}</strong>
                    </li>
                    <li v-if="item.phone && item.insurer" class="mb-4 md:w-1/2">
                      Numer telefonu: <strong>{{ item.phone }}</strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              v-if="
                this.$store.state.starpack &&
                  this.$store.state.starpack.documents.length > 0
              "
              class="flex flex-wrap -mx-4 text-xs font-medium text-black mb-7"
            >
              <div
                v-for="document in this.$store.state.starpack.documents"
                :key="document.id"
                class="px-4 mb-2"
              >
                <a :href="document.url" target="_blank" class="flex">
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.3327 6.33283C13.3257 6.26775 13.3123 6.20365 13.2927 6.14158V6.07783C13.2606 6.00499 13.2179 5.93805 13.166 5.87949L9.16602 1.62949C9.11091 1.5744 9.0479 1.52897 8.97935 1.49491H8.91935L8.70602 1.41699H4.66602C4.13558 1.41699 3.62687 1.64088 3.2518 2.03939C2.87673 2.43791 2.66602 2.97841 2.66602 3.54199V13.4587C2.66602 14.0222 2.87673 14.5627 3.2518 14.9613C3.62687 15.3598 4.13558 15.5837 4.66602 15.5837H11.3327C11.8631 15.5837 12.3718 15.3598 12.7469 14.9613C13.122 14.5627 13.3327 14.0222 13.3327 13.4587V6.37533C13.3327 6.37533 13.3327 6.37533 13.3327 6.33283ZM9.33268 3.83241L11.0593 5.66699H9.33268V3.83241ZM11.9993 13.4587C11.9993 13.6465 11.9291 13.8267 11.8041 13.9595C11.6791 14.0924 11.5095 14.167 11.3327 14.167H4.66602C4.4892 14.167 4.31964 14.0924 4.19461 13.9595C4.06959 13.8267 3.99935 13.6465 3.99935 13.4587V3.54199C3.99935 3.35413 4.06959 3.17396 4.19461 3.04113C4.31964 2.90829 4.4892 2.83366 4.66602 2.83366H7.99935V6.37533C7.99935 6.56319 8.06959 6.74335 8.19461 6.87619C8.31963 7.00903 8.4892 7.08366 8.66602 7.08366H11.9993V13.4587Z"
                      fill="black"
                    />
                  </svg>
                  <div class="ml-1 underline">{{ document.code }}</div>
                </a>
              </div>
            </div>

            <div class="punkta_comparer_acceptances mb-14 md:w-4/5">
              <div>
                <ValidationObserver ref="form" style="display: block">
                  <form class="" @submit.prevent="onSubmit()">
                    <div class="text-sm punkta_comparer_userbol">
                      <div class="mb-2">
                        Czy wszyscy ubezpieczeni znajdują się obecnie na terenie
                        Polski?
                      </div>
                      <validation-provider
                        :rules="{
                          required_persons_located: true
                        }"
                        v-slot="{ errors }"
                        slim
                      >
                        <label class="block cursor-pointer click-box">
                          <div class="switch">
                            <div class="relative right-10">
                              {{ personsLocated ? 'Tak' : 'Nie' }}
                            </div>
                            <input
                              type="checkbox"
                              name="personsLocated"
                              v-model="personsLocated"
                            />
                            <span class="slider round"></span>
                          </div>
                        </label>
                        <div class="relative text-sm text-red-100 error">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>

                    <div
                      class="clausesRequiredBox"
                      v-if="clauses && clauses.required"
                    >
                      <h3 class="mb-5 text-lg font-medium">
                        Oświadczenia wymagane do zakupu polisy
                      </h3>
                      <label class="container flex !mt-4 !mb-4">
                        <input
                          id="checkAll"
                          v-model="check"
                          type="checkbox"
                          v-on:click="checkAll()"
                        />
                        <span class="checkmark"></span>
                        <div class="ml-2 text-sm md:font-bold">
                          Akceptuję wszystkie wymagane oświadczenia
                        </div>
                      </label>
                      <validation-provider
                        v-for="item in clauses.required"
                        :key="item.id"
                        :rules="{
                          required: { allowFalse: false }
                        }"
                        v-slot="{ errors }"
                      >
                        <label class="container flex text-[13px] !mb-7">
                          <input
                            type="checkbox"
                            immediate
                            v-model="checkboxs[item.code]"
                            :name="item.code"
                            :value="false"
                          />
                          <span class="checkmark"></span>
                          <div class="ml-2">
                            <ReadMore
                              more-str="(więcej)"
                              :text="item.content"
                              less-str="(mniej)"
                              :max-chars="150"
                            ></ReadMore>
                          </div>
                        </label>
                        <div class="relative text-sm text-red-100 error ">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div v-if="clauses && clauses.not_required">
                      <h3 class="mb-5 text-lg font-medium">
                        Oświadczenia niewymagane do zakupu polisy (opcjonalne)
                      </h3>
                      <validation-provider
                        v-for="item in clauses.not_required"
                        :key="item.id"
                        :rules="{
                          required: false
                        }"
                        v-slot="{ errors }"
                      >
                        <label class="container flex text-[13px] !mb-7">
                          <input
                            type="checkbox"
                            v-model="checkboxs[item.code]"
                            :name="item.code"
                            :value="false"
                            immediate
                          />
                          <span class="checkmark"></span>
                          <div class="ml-2">
                            <ReadMore
                              more-str="(więcej)"
                              :text="item.content"
                              less-str="(mniej)"
                              :max-chars="150"
                            ></ReadMore>
                          </div>
                        </label>
                        <div class="relative text-sm text-red-100 error ">
                          {{ errors[0] }}
                        </div>
                      </validation-provider>
                    </div>
                    <div class="flex justify-between w-full">
                      <router-link
                        to="/form-step-3"
                        class="flex justify-center w-32 py-4 text-xs font-bold text-black border border-black rounded-lg comparer-button text-opacity-60 border-opacity-20 md:w-40"
                      >
                        <svg
                          class="self-center mx-1 svg-button"
                          width="16"
                          height="6"
                          viewBox="0 0 16 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.556272 3.32599C0.591976 3.43105 0.645515 3.52704 0.713812 3.60844L2.58928 5.74828C2.73054 5.90945 2.92214 6 3.12191 6C3.32169 6 3.51328 5.90945 3.65454 5.74828C3.79581 5.5871 3.87517 5.3685 3.87517 5.14056C3.87517 4.91263 3.79581 4.69403 3.65454 4.53285L3.05439 3.85666L14.7498 3.85666C14.9488 3.85666 15.1396 3.76649 15.2803 3.60597C15.421 3.44545 15.5 3.22774 15.5 3.00073C15.5 2.77372 15.421 2.55601 15.2803 2.3955C15.1396 2.23498 14.9488 2.1448 14.7498 2.1448L3.0544 2.1448L3.65454 1.46861C3.72486 1.38904 3.78067 1.29437 3.81876 1.19007C3.85684 1.08577 3.87645 0.973891 3.87645 0.860897C3.87645 0.747904 3.85684 0.636029 3.81876 0.531725C3.78067 0.427422 3.72486 0.332755 3.65454 0.253185C3.58481 0.172959 3.50183 0.109283 3.41042 0.0658282C3.319 0.0223736 3.22095 8.3388e-07 3.12191 8.25222e-07C3.02288 8.16564e-07 2.92483 0.0223735 2.83341 0.0658282C2.74199 0.109283 2.65902 0.172959 2.58928 0.253185L0.713812 2.39302C0.645515 2.47442 0.591976 2.57041 0.556272 2.67548C0.48124 2.88386 0.48124 3.1176 0.556272 3.32599Z"
                            fill="black"
                          />
                        </svg>
                        <!-- <img class="self-center mx-1" src="@/assets/img/punkta_comparer/arrow-left.svg" alt="arrow"> -->
                        <div class="mx-1">Wstecz</div>
                      </router-link>

                      <button
                        type="submit"
                        class="flex justify-center w-32 py-4 text-xs font-bold text-white bg-orange-100 rounded-lg comparer-button md:w-40"
                      >
                        <div class="mx-1">Kupuję i płacę</div>
                        <svg
                          class="self-center mx-1"
                          width="15"
                          height="6"
                          viewBox="0 0 15 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.9437 2.67401C14.908 2.56895 14.8545 2.47296 14.7862 2.39156L12.9107 0.251722C12.7695 0.0905471 12.5779 0 12.3781 0C12.1783 0 11.9867 0.0905471 11.8455 0.251722C11.7042 0.412898 11.6248 0.631499 11.6248 0.859435C11.6248 1.08737 11.7042 1.30597 11.8455 1.46715L12.4456 2.14334H0.750187C0.551225 2.14334 0.360412 2.23351 0.219725 2.39403C0.0790375 2.55455 0 2.77226 0 2.99927C0 3.22628 0.0790375 3.44399 0.219725 3.6045C0.360412 3.76502 0.551225 3.8552 0.750187 3.8552H12.4456L11.8455 4.53139C11.7751 4.61096 11.7193 4.70563 11.6812 4.80993C11.6432 4.91423 11.6236 5.02611 11.6236 5.1391C11.6236 5.2521 11.6432 5.36397 11.6812 5.46827C11.7193 5.57258 11.7751 5.66724 11.8455 5.74681C11.9152 5.82704 11.9982 5.89072 12.0896 5.93417C12.181 5.97763 12.2791 6 12.3781 6C12.4771 6 12.5752 5.97763 12.6666 5.93417C12.758 5.89072 12.841 5.82704 12.9107 5.74681L14.7862 3.60698C14.8545 3.52558 14.908 3.42959 14.9437 3.32452C15.0188 3.11614 15.0188 2.8824 14.9437 2.67401Z"
                            fill="white"
                          />
                        </svg>
                        <!-- <img class="self-center mx-1" src="@/assets/img/punkta_comparer/arrow-right.svg" alt="arrow"> -->
                      </button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>

          <Chat />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//<Form v-bind:services="this.$store.state.services" />
import Chat from './components/Chat.vue'
import ReadMore from './components/ReadMore.vue'

export default {
  components: {
    Chat,
    ReadMore
  },
  data () {
    return {
      uris: [],
      clauses: '',
      check: false,
      checkboxs: [],
      personsLocated: false
    }
  },

  mounted () {
    window.scrollTo(0, 0)
    this.$store.commit('setStep', 3)
    if (this.$store.state.starpack && this.$store.state.starpack.result_info) {
      this.getPolicyClauses()
      // this.sendEmail()

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'travelInsuranceCalculator', //stała
        action: 'ecommerce', //stała
        label: 'checkout - 2', //stała wartość checkout + krok checkout
        ecommerce: {
          currencyCode: 'PLN', //stała
          checkout: {
            actionField: {
              step: 2 //stała
            }
          },
          products: [this.$store.state.starpackEvent]
        }
      })
    }
  },
  methods: {
    getPolicy (starpack, checkboxs, terms_accept) {
      let _this = this
      // _this.$store.commit('setLoader', true)
      // _this.$store.commit('setShowCustomModal', true)
      // setTimeout(function () {
      //   _this.slideText(3)
      // }, 500);

      _this.axios
        .post(
          // '/wp-json/travel/v1/getPolicy',
          '/wp-json/travel/v1/getPolicy',
          {
            starpack: starpack,
            addresses: _this.$store.state.addresses,
            pesel: _this.$store.state.clientPesel,
            starpack_name: _this.$store.state.starpack.result_info.name,
            clauses: checkboxs,
            terms_accept: terms_accept,
            salesforceId: _this.$store.state.leadSalesforceId
          }
        )
        .then(function (response) {
          if (response && response.data && response.data.code == 200) {
            _this.$store.commit('setPolicy', response.data[0].policy)
            // _this.$store.commit('setLoader', false)
            // _this.$store.commit('setShowCustomModal', false)
            _this.updateLead(response)
            _this.createProduct(response)
            _this.getPayments(response.data.policy_token)
          }
        })
        .catch(function (error) {
          console.log(error)
          // _this.$store.commit('setLoader', false)
          _this.$store.commit('setShowCustomModal', false)
          _this.$store.commit('setShowModal', true)
        })
    },
    createProduct (response) {
      let _this = this
      let insurer = _this.$store.state.starpackEvent.brand
      switch (insurer) {
        case "AXA":
          insurer = "AXA Direct"
          break;
        case "Europ Assistance":
          insurer = "Europ"
          break;
      }
      let policy = response.data[0].policy
      this.axios
        .post('/wp-json/travel/v1/createProduct', {
          product: {
            copportunity_id: _this.$store.state.leadSalesforceId,
            status: 'nowa sprzedaż',
            type: 'Polisa turystyczna',
            instalments: 1,
            insurer:insurer,
            policy_start_date: _this.$moment(response.data.insurance_start_date,'DD/MM/YYYY').format('YYYY-MM-DD'),
            policy_end_date: _this.$moment(response.data.insurance_end_date,'DD/MM/YYYY').format('YYYY-MM-DD'),
            sales_channel: 'Online',
            total_premium: policy.total_amount,
            policy_number: policy.policy_number,
            policy_token: policy.policy_token,
            cancelled: false,
            payment_type: 'online'
          }
        })
        .then(function (response) {
          if (response && response.data && response.data.success) {
            _this.$store.commit('setProductSalesforceId', response.data.salesforceId)
          }
        })
        .catch(function (error) {
          console.log(error)
          // _this.$store.commit('setShowModal', true)
        })
    },
    updateLead (response) {
      let _this = this
      let policy = response.data[0].policy
      this.axios
        .post('/wp-json/travel/v1/updateLead', {
          lead: {
            salesforce_id: _this.$store.state.leadSalesforceId,
            calculation_token: _this.$store.state.calculationToken,
            declared_policy_number: policy.policy_number
          }
        })
        .catch(function (error) {
          console.log(error)
          // _this.$store.commit('setShowModal', true)
        })
    },
    getPolicyClauses () {
      let _this = this
      _this.$store.commit('setLoader', true)
      _this.axios
        .post(
          // '/wp-json/travel/v1/getPolicyClauses',
          '/wp-json/travel/v1/getPolicyClauses',
          {
            name: _this.$store.state.starpack.result_info.name
          }
        )
        .then(function (response) {
          if (response && response.data && response.data.code == 200) {
            _this.clauses = response.data.policy_clauses

            _this.$store.commit('setLoader', false)
          }
        })
        .catch(function (error) {
          console.log(error)
          _this.$store.commit('setLoader', false)
          _this.$store.commit('setShowModal', true)
        })
    },
    checkAll () {
      let _this = this
      this.check = !this.check

      this.clauses.required.forEach(function (clause) {
        _this.checkboxs['' + clause.code] = _this.check
      })

      document
        .querySelectorAll('.clausesRequiredBox input')
        .forEach(element => {
          element.checked = _this.check
        })

      // if (this.check) {
      //   this.clauses.required.forEach(function (clause) {
      //     if (!_this.checkboxs.includes(clause.code)) {
      //       _this.checkboxs['' + clause.code] = true
      //     }
      //   })
      // } else {
      //   this.clauses.required.forEach(function (clause) {
      //     _this.checkboxs['' + clause.code] = false
      //   })
      // }
      //   this.clauses.required.forEach(function (clause) {
      //       _this.checkboxs['' + clause.code] = _this.check
      //   })
      // this.$refs.form.validate()
    },
    onSubmit () {
      this.$refs.form.validate().then(success => {
        if (!success) {
          const errors = Object.entries(this.$refs.form.errors)
          .map(([key, value]) => ({ key, value }))
          .filter(error => error["value"].length);
          if(this.$refs.form.refs[errors[0]["key"]]){
            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
            behavior: "smooth",
            block: "start"
            });
          }
          return
        }
        let _this = this
        // _this.$store.commit('setLoader', true)
        _this.$store.commit('setShowCustomModal', true)
        setTimeout(function () {
          _this.slideText(3)
        }, 100);

        let granted_policy_clauses = []
        if (_this.clauses.required) {
          _this.clauses.required.forEach(clause => {
            granted_policy_clauses.push({
              code: clause.code,
              content: clause.content,
              check: _this.checkboxs[clause.code] ? true : false
            })
          })
        }
        if (_this.clauses.not_required) {
          _this.clauses.not_required.forEach(clause => {
            granted_policy_clauses.push({
              code: clause.code,
              content: clause.content,
              check: _this.checkboxs[clause.code] ? true : false
            })
          })
        }
        var tmpArray = _this.$store.state.clientTermsAccept
        tmpArray.push({
          code: 'personsLocatedPL',
          content:
            'Czy wszyscy ubezpieczeni znajdują się obecnie na terenie Polski?',
          check: true
        })

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ ecommerce: null })
        window.dataLayer.push({
          event: 'travelInsuranceCalculator', //stała
          action: 'ecommerce', //stała
          label: 'checkout - 3', //stała wartość checkout + krok checkout
          ecommerce: {
            currencyCode: 'PLN', //stała
            checkout: {
              actionField: {
                step: 3 //stała
              }
            },
            products: [_this.$store.state.starpackEvent]
          }
        })

        _this.getPolicy(
          _this.$store.state.starpack,
          granted_policy_clauses,
          tmpArray
        )
      })
    },
    sendEmail () {
      let _this = this
      _this.$store.commit('setLoader', true)
      this.axios
        .post('/wp-json/travel/v1/sendEmail', {
          event_name: 'travel_policy_offer_documents',
          tu_name: _this.$store.state.starpack.result_info.name,
          attributes: {
            event: {
              uuid: _this.$store.state.starpack.uuid,
              receiver: _this.$store.state.clientEmail,
              app: 'travel',
              event_name: 'travel_policy_offer_documents',
              server: 'wp'
            },
            payload: {
              tu_name: _this.$store.state.starpack.result_info.name,
              tu_logo_url: 'Logo ubezpieczyciela (url)',
              policy_price: '' + _this.$store.state.starpack.price,
              policy_start_date: _this.$store.state.dateFrom,
              policy_end_date: _this.$store.state.dateTo
            }
          }
        })
        .then(function (response) {
          if (response && response.data && response.data.code == 200) {
            _this.$store.commit('setLoader', false)
          }
        })
        .catch(function (error) {
          console.log(error)
          _this.$store.commit('setLoader', false)
          _this.$store.commit('setShowModal', true)
        })
    },
    getPayments (policy_token) {
      let _this = this
      // _this.$store.commit('setLoader', true)
      _this.axios
        .post(
          // '/wp-json/travel/v1/getPolicyClauses',
          '/wp-json/travel/v1/getPayments',
          {
            partner: _this.$store.state.partner ? _this.$store.state.partner : '',
            url: window.location.origin+window.location.pathname,
            data: {
              payment_token: '',
              first_name: _this.$store.state.clientName,
              surname: _this.$store.state.clientSurname,
              policy_token: policy_token,
              policy_no: _this.$store.state.policySummary.policy_number,
              email: _this.$store.state.clientEmail,
              amount: _this.$store.state.policySummary.total_amount * 100,
              tu_name: 'fittravel',
              calculation_token: _this.$store.state.starpack.calculation_token,
              account_number: _this.$store.state.policySummary.account_number,
              validity_time: 2700,
              link_validity_time: 1800,
              salesforceId: _this.$store.state.leadSalesforceId,
              source: 'travel'
            },

          }
        )
        .then(function (response) {
          if (response && response.data && response.data.code == 200) {
            // _this.$store.commit('setLoader', false)
            _this.$store.commit('setShowCustomModal', false)

            if(_this.$store.state.isInIframe){
              if (!parent?.postMessage) return
              parent.postMessage({ redirectUrl: response.data.redirect_url}, '*')
            }
            else{
              window.location.href = response.data.redirect_url
            }

          }
        })
        .catch(function (error) {
          console.log(error)
          // _this.$store.commit('setLoader', false)
          _this.$store.commit('setShowCustomModal', false)
          _this.$store.commit('setShowModal', true)
        })
    },
  }
}
</script>
